import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import {
  Timestamp,
  addDoc,
  collection,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import Role from "helper/constant/roleKeys";
import ErrorMessages from "helper/errorMessages";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import React, { useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddUsers() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const dropdRoleValues = [Role.role1];
  const location = useLocation();
  const navigate = useNavigate();

  const [users, setUsers] = useState({
    name: "",
    email: "",
    password: "",
    confirm_password: "",
    role: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    password: "",
    confirm_password: "",
    role: "",
  });


  // MARK: use layout method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.userEditHeading
      : CommonHeadings.userAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const validateForm = (data) => {
    const errors = {};

    if (!data.name) {
      errors.name = ErrorMessages.name;
    }
    if (!data.email.trim()) {
      errors.email = ErrorMessages.email;
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = ErrorMessages.emailPattern;
    }
    if (!data.password) {
      errors.password = ErrorMessages.password;
    } else if (!data.password) {
      errors.password = ErrorMessages.passwordLength;
    }
    if (!data.confirm_password === data.passowrd) {
      errors.confirm_password = ErrorMessages.confirmPassword;
    }
    if (!data.role) {
      errors.role = ErrorMessages.role;
    }

    return errors;
  };

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    const { name, value } = e.target;

    setUsers({
      ...users,
      [name]: value,
    });
  };

  //   this function is only used for the dropdown input where users can select the role by selecting into the dropdown
  const inputDropMaritalChange = (e) => {
    const { name, value } = e.target;

    setUsers({
      ...users,
      [name]: value,
    });
  };

  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(users);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      userSignUpApi();
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(users);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      userSignUpApi(true);
    }
  };

  // MARK: reset values function
  function ResetValues() {
    setUsers({
      name: "",
      email: "",
      password: "",
      confirm_password: "",
      role: "",
    });
  }

  const userSignUpApi = (edit) => {
    const auth = getAuth();
    createUserWithEmailAndPassword(auth, users.email, users.password)
      .then(async (userCredential) => {
        setLoading1(false);
        // create users
        const user = userCredential.user;
        const uid = user.uid;
        const createdAt = Timestamp.fromDate(new Date()).toMillis();

        await addDoc(collection(dbFirestore, TableName.users), {
          created_at: createdAt,
          updated_at: createdAt,
          name: users.name.toLowerCase(),
          email: users.email.toLowerCase(),
          role: users.role.toLowerCase(),
          user_id: uid,
        });
        if (edit) {
          toast.success(ToastMessages.userAdd);
          setTimeout(() => {
            setLoading2(false);
            // when user press on save + next
            navigate(RoutingPaths.addUsers);
            ResetValues();
          }, 600);
        } else {
          toast.success(ToastMessages.userAdd);
          setTimeout(() => {
            setLoading1(false);
            navigate(RoutingPaths.usersList);
          }, 600);
        }
      })
      .catch((error) => {
        setLoading1(false);
        const errorCode = error.code;
        const errorMessage = error.message;
        if (errorCode === "auth/invalid-credential") {
          toast.error(ErrorMessages.loginError);
        } else {
          toast.error(errorMessage);
        }
      });
  };


  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-1 mt-3" headingName={CommonHeadings.userAddHeading} />
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row mt-4">
              <div className="col-12 col-md-6">
                <label htmlFor="name" className="input__valid">Name</label>
                <InputText
                  name="name"
                  value={users.name}
                  onChange={inputChange}
                  id="name"
                  type="text"
                  placeholder="Enter your name"
                />
                {isSubmitted && (
                  <small id="name" className="p-error">
                    {errors.name}{" "}
                  </small>
                )}
              </div>

              <div className="field col-12 col-md-6">
                <label htmlFor="email" className="input__valid">Email</label>
                <InputText
                  name="email"
                  value={users.email}
                  onChange={inputChange}
                  id="email"
                  type="text"
                  placeholder="e.g. abc@mail.com"
                />
                {isSubmitted && (
                  <small id="email" className="p-error">
                    {errors.email}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="password" className="input__valid">Password</label>
                <Password
                  name="password"
                  value={users.password}
                  onChange={inputChange}
                  id="confirmPassword"
                  placeholder="Enter your password"
                  toggleMask
                  feedback={false}
                  tabIndex={1}
                ></Password>
                {isSubmitted && (
                  <small id="password" className="p-error">
                    {errors.password}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 ">
                <label htmlFor="confirm_password" className="input__valid">Confirm Password</label>
                <Password
                  name="confirm_password"
                  value={users.confirm_password}
                  onChange={inputChange}
                  id="confirm_password"
                  placeholder="Re-enter your password"
                  toggleMask
                  feedback={false}
                  tabIndex={1}
                ></Password>
                {isSubmitted && (
                  <small id="confirm_password" className="p-error">
                    {errors.confirm_password}
                  </small>
                )}
              </div>

              <div className="field col-12 col-md-6">
                <label htmlFor="role" className="input__valid">Select Role</label>
                <Dropdown
                  name="role"
                  value={users.role}
                  onChange={inputDropMaritalChange}
                  options={dropdRoleValues}
                  optionLabel="name"
                  placeholder="Select your role"
                />
                {isSubmitted && (
                  <small id="role" className="p-error">
                    {errors.role}
                  </small>
                )}
              </div>
            </div>
          </div>

          <BottomButtons
            label={ButtonLabels.saveLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddUsers;
